(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["efi-live-add-ons"] && !Shopify.designMode) return;
  try {
    function sfgEfiFormatMoney(cents, currency) {
  try {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-CA',
      {
        style: 'currency',
        currency: currency || 'CAD'
      }
    ).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2);
  }
}


function sfgEfiTuneAddonProperties(sourceProperties) {

  const output = {};
  const wantedKeys = [
    'VIN',
    'Vehicle',
    'Transmission'
  ];

  const source =
    sourceProperties && typeof sourceProperties === 'object'
      ? sourceProperties
      : {};

  wantedKeys.forEach((wantedKey) => {

    const actualKey =
      Object.keys(source).find(
        (key) =>
          String(key).trim().toLowerCase() ===
          wantedKey.toLowerCase()
      );

    if (!actualKey) return;

    const value = source[actualKey];

    if (value !== '' && value != null) {
      output[wantedKey] = value;
    }

  });

  return output;
}


function sfgEfiNormalizeAuthCode(value) {
  const clean = String(value || '')
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase()
    .slice(0, 18);

  return clean.match(/.{1,6}/g)?.join('-') || '';
}


function sfgEfiAuthCodeIsComplete(value) {
  const clean = String(value || '')
    .replace(/[^A-Za-z0-9]/g, '');

  return clean.length === 18;
}


function sfgEfiUpdateSavedDefaultLabel(
  input,
  noteSelector,
  normalizer
) {

  if (!input) return;

  const field =
    input.closest('.sfg-efi-field');

  const note =
    field?.querySelector(noteSelector);

  if (!note) return;


  const normalize =
    typeof normalizer === 'function'
      ? normalizer
      : (value) => String(value || '');


  const savedDefault =
    normalize(
      input.dataset.sfgEfiDefault || ''
    );

  const currentValue =
    normalize(
      input.value || ''
    );


  note.hidden = !(
    savedDefault !== '' &&
    currentValue === savedDefault
  );

}


function sfgEfiUpdateVisibility(block) {

  const hardwareChoice =
    block.querySelector(
      'input[data-sfg-efi-hardware-choice]:checked'
    );

  const licenseFields =
    block.querySelector(
      '[data-sfg-efi-license-fields]'
    );

  if (licenseFields) {

    const showLicenseFields =
      hardwareChoice?.value === 'vin-license' &&
      hardwareChoice?.dataset.requiresAutocalCredentials === 'true';

    licenseFields.hidden =
      !showLicenseFields;

  }


  block
    .querySelectorAll('[data-sfg-addon-group]')
    .forEach((group) => {

      const addonYes =
        group.querySelector(
          'input[data-sfg-addon-choice][value="yes"]:checked'
        );

      const variantWrap =
        group.querySelector(
          '[data-sfg-addon-variant-wrap]'
        );

      if (variantWrap) {
        variantWrap.hidden = !addonYes;
      }

    });

}


function sfgEfiUpdateTotal(block) {

  let total =
    Number(block.dataset.basePrice || 0);


  const hardwareChoice =
    block.querySelector(
      'input[data-sfg-efi-hardware-choice]:checked'
    );

  if (
    hardwareChoice &&
    hardwareChoice.value !== 'none'
  ) {

    total +=
      Number(
        hardwareChoice.dataset.addonUnitPrice || 0
      );

  }


  block
    .querySelectorAll('[data-sfg-addon-group]')
    .forEach((group) => {

      const addonYes =
        group.querySelector(
          'input[data-sfg-addon-choice][value="yes"]:checked'
        );

      if (!addonYes) return;


      let qty =
        Number(addonYes.dataset.addonQuantity || 1);

      let unitPrice =
        Number(addonYes.dataset.addonUnitPrice || 0);


      const variantSelect =
        group.querySelector(
          '[data-sfg-addon-variant]'
        );

      if (variantSelect) {

        const option =
          variantSelect.selectedOptions[0];

        unitPrice =
          Number(option?.dataset.price || 0);

      }


      total += unitPrice * qty;

    });


  const output =
    block.querySelector(
      '[data-sfg-configured-total]'
    );

  if (output) {

    output.textContent =
      sfgEfiFormatMoney(
        total,
        block.dataset.currency
      );

  }

}


let sfgEfiVariantSelectionRequest = 0;


function sfgEfiNormalizeShopifyId(value) {

  const match =
    String(value || '')
      .match(/(\d+)$/);

  return match
    ? match[1]
    : '';

}


function sfgEfiVariantPriceToCents(variant) {

  const amount =
    Number(
      variant?.price?.amount
    );

  if (!Number.isFinite(amount)) {
    return null;
  }

  return Math.round(
    amount * 100
  );

}


document.addEventListener(
  'shopify:product:select',
  (event) => {

    const eventProductId =
      sfgEfiNormalizeShopifyId(
        event.product?.id
      );

    if (!eventProductId) {
      return;
    }


    const matchingBlocks =
      Array.from(
        document.querySelectorAll(
          '[data-sfg-efi-addons]'
        )
      ).filter(
        (block) =>
          sfgEfiNormalizeShopifyId(
            block.dataset.productId
          ) === eventProductId
      );

    if (!matchingBlocks.length) {
      return;
    }


    const requestToken =
      String(
        ++sfgEfiVariantSelectionRequest
      );


    matchingBlocks.forEach(
      (block) => {

        block.dataset.variantPriceRequest =
          requestToken;

      }
    );


    const variantPromise =
      event.promise;

    if (
      !variantPromise ||
      typeof variantPromise.then !== 'function'
    ) {
      return;
    }


    variantPromise
      .then(
        ({ variant }) => {

          if (!variant) {
            return;
          }


          const basePrice =
            sfgEfiVariantPriceToCents(
              variant
            );

          if (basePrice == null) {
            return;
          }


          const currency =
            String(
              variant?.price?.currencyCode || ''
            ).trim();


          matchingBlocks.forEach(
            (block) => {

              if (
                !block.isConnected ||
                block.dataset.variantPriceRequest !== requestToken
              ) {
                return;
              }


              block.dataset.basePrice =
                String(basePrice);


              if (currency) {
                block.dataset.currency =
                  currency;
              }


              sfgEfiUpdateTotal(block);

            }
          );

        }
      )
      .catch(
        (error) => {

          if (error?.name === 'AbortError') {
            return;
          }

          console.warn(
            'SFG EFI Live variant price update failed:',
            error
          );

        }
      );

  }
);





document.addEventListener(
  'input',
  (event) => {

    const serialInput =
      event.target.closest(
        '[data-sfg-efi-autocal-serial]'
      );

    if (serialInput) {

      sfgEfiUpdateSavedDefaultLabel(
        serialInput,
        '[data-sfg-efi-serial-label-note]'
      );

      return;
    }


    const authInput =
      event.target.closest(
        '[data-sfg-efi-auth-code]'
      );

    if (authInput) {

      authInput.value =
        sfgEfiNormalizeAuthCode(
          authInput.value
        );

      sfgEfiUpdateSavedDefaultLabel(
        authInput,
        '[data-sfg-efi-auth-label-note]',
        sfgEfiNormalizeAuthCode
      );

      return;
    }


    /*
     * Uppercase the existing vehicle-information VIN field.
     * The field can remain in your separate vehicle Custom Liquid block.
     */
    if (
      event.target.matches(
        'input[name="properties[VIN]"], input[name="properties[Vin]"], input[name="properties[vin]"]'
      )
    ) {

      event.target.value =
        event.target.value.toUpperCase();

    }

  }
);


document.addEventListener(
  'change',
  (event) => {

    const block =
      event.target.closest(
        '[data-sfg-efi-addons]'
      );

    if (!block) return;


    sfgEfiUpdateVisibility(block);
    sfgEfiUpdateTotal(block);

  }
);


document.addEventListener(
  'click',
  async (event) => {

    const button =
      event.target.closest(
        'button[type="submit"][name="add"]'
      );

    if (!button) return;


    const form =
      button.form;

    if (!form) return;


    const block =
      Array.from(
        document.querySelectorAll(
          '[data-sfg-efi-addons]'
        )
      ).find(
        (item) =>
          item.dataset.formId === form.getAttribute('id')
      );


    if (!block) return;


    const hardwareChoice =
      block.querySelector(
        'input[data-sfg-efi-hardware-choice]:checked'
      );

    const hasHardwarePurchase =
      hardwareChoice &&
      hardwareChoice.value !== 'none';


    const anyAddon =
      block.querySelector(
        'input[data-sfg-addon-choice][value="yes"]:checked'
      );


    /*
     * Nothing extra selected:
     * leave Horizon's normal Add to Cart behavior alone.
     */
    if (
      !hasHardwarePurchase &&
      !anyAddon
    ) {
      return;
    }


    /*
     * Extras are selected, so build the whole order in one
     * cart/add.js request instead of letting Horizon add only
     * the main tune.
     */
    event.preventDefault();
    event.stopImmediatePropagation();


    if (!form.reportValidity()) {
      return;
    }


    if (block.dataset.loading === '1') {
      return;
    }

    block.dataset.loading = '1';


    const errorBox =
      block.querySelector(
        '[data-sfg-addon-error]'
      );

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }


    try {

      const formData =
        new FormData(form);


      const mainVariantId =
        Number(formData.get('id'));

      const mainQuantity =
        Number(formData.get('quantity')) || 1;


      if (!mainVariantId) {

        throw new Error(
          'Could not determine the selected tuning product.'
        );

      }


      const properties = {};


      for (
        const [key, value]
        of formData.entries()
      ) {

        const match =
          key.match(
            /^properties\[(.+)\]$/
          );

        if (!match) continue;


        const cleanValue =
          typeof value === 'string'
            ? value.trim()
            : value;


        if (
          cleanValue !== '' &&
          cleanValue != null
        ) {

          properties[match[1]] =
            cleanValue;

        }

      }


      const mainItem = {
        id: mainVariantId,
        quantity: mainQuantity
      };


      if (
        Object.keys(properties).length
      ) {

        mainItem.properties =
          properties;

      }


      const items = [
        mainItem
      ];


      /*
       * EFI Live 3-way hardware/licensing choice.
       */
      if (hasHardwarePurchase) {

        const hardwareVariantId =
          Number(
            hardwareChoice.dataset.addonVariantId
          );

        if (!hardwareVariantId) {

          throw new Error(
            'Could not determine the selected EFI Live hardware or license.'
          );

        }


        if (
          hardwareChoice.value === 'vin-license' &&
          hardwareChoice.dataset.requiresAutocalCredentials === 'true'
        ) {

          const serialInput =
            block.querySelector(
              '[data-sfg-efi-autocal-serial]'
            );

          const authInput =
            block.querySelector(
              '[data-sfg-efi-auth-code]'
            );


          const serial =
            String(
              serialInput?.value || ''
            ).trim();

          const authCode =
            sfgEfiNormalizeAuthCode(
              authInput?.value || ''
            );


          if (!serial) {

            throw new Error(
              'Enter the AutoCal Serial for the VIN License.'
            );

          }


          if (
            !sfgEfiAuthCodeIsComplete(
              authCode
            )
          ) {

            throw new Error(
              'Enter the complete 18-character Auth Code.'
            );

          }


          if (authInput) {
            authInput.value = authCode;
          }


          items.push({
            id: hardwareVariantId,
            quantity: 1,
            properties: {
              'AutoCal Serial': serial,
              'Auth Code': authCode
            }
          });

        } else {

          items.push({
            id: hardwareVariantId,
            quantity: 1
          });

        }

      }


      /*
       * Ordinary optional add-ons.
       * Duplicate variant IDs are combined into one cart line.
       */
      const itemMap =
        new Map();


      function addItem(
        variantId,
        quantity,
        isTuneAddon = false
      ) {

        const id =
          Number(variantId);

        const qty =
          Number(quantity);


        if (!id || qty < 1) return;


        const tuneAddon =
          Boolean(isTuneAddon);

        const key =
          `${id}:${tuneAddon ? 'tune' : 'plain'}`;

        const existing =
          itemMap.get(key);


        if (existing) {
          existing.quantity += qty;
          return;
        }


        itemMap.set(
          key,
          {
            id,
            quantity: qty,
            isTuneAddon: tuneAddon
          }
        );

      }


      block
        .querySelectorAll(
          '[data-sfg-addon-group]'
        )
        .forEach((group) => {

          const yes =
            group.querySelector(
              'input[data-sfg-addon-choice][value="yes"]:checked'
            );

          if (!yes) return;


          let variantId =
            yes.dataset.addonVariantId;


          if (!variantId) {

            const select =
              group.querySelector(
                '[data-sfg-addon-variant]'
              );

            variantId =
              select?.value;

          }


          addItem(
            variantId,
            yes.dataset.addonQuantity || 1,
            group.dataset.sfgTuneAddon === 'true'
          );

        });


      const tuneAddonProperties =
        sfgEfiTuneAddonProperties(properties);


      Array.from(
        itemMap.values()
      ).forEach(
        ({id, quantity, isTuneAddon}) => {

          const item = {
            id,
            quantity
          };


          if (
            isTuneAddon &&
            Object.keys(tuneAddonProperties).length
          ) {
            item.properties = {
              ...tuneAddonProperties
            };
          }


          items.push(item);

        }
      );


      /*
       * Add the tune + selected add-ons through Shopify's AJAX
       * cart endpoint. This matches Horizon's own batch-add path
       * and avoids the Storefront API/SFAPI 400 issue.
       */
      const root =
        window.Shopify?.routes?.root || '/';


      const cartComponents =
        Array.from(
          document.querySelectorAll(
            'cart-items-component'
          )
        );


      const sectionIds =
        Array.from(
          new Set(
            cartComponents
              .map(
                (component) =>
                  component.dataset.sectionId
              )
              .filter(Boolean)
          )
        );


      const payload = {
        items
      };


      if (sectionIds.length) {
        payload.sections =
          sectionIds.join(',');
      }


      const response =
        await fetch(
          root + 'cart/add.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },
            body: JSON.stringify(
              payload
            )
          }
        );


      const result =
        await response.json();


      if (!response.ok) {

        throw new Error(
          result.description ||
          result.message ||
          'Unable to add the configured products to cart.'
        );

      }


      /*
       * Horizon's cart-items component listens for the standard
       * cart-lines-update event. Supplying the bundled sections
       * lets it refresh the existing drawer without a page load.
       */
      const cartUpdateEvent =
        new CustomEvent(
          'shopify:cart:lines-update',
          {
            bubbles: true
          }
        );


      cartUpdateEvent.promise =
        Promise.resolve({
          detail: {
            sections:
              result.sections || undefined,
            source: 'sfg-addons',
            didError: false
          }
        });


      document.dispatchEvent(
        cartUpdateEvent
      );


      /*
       * Open Horizon's native cart drawer.
       */
      const openCart =
        window.Shopify?.actions?.openCart;


      if (openCart) {

        await openCart();

      } else {

        window.location.assign(
          root + 'cart'
        );

      }


    } catch (error) {

      delete block.dataset.loading;


      if (errorBox) {

        errorBox.textContent =
          error.message ||
          'There was a problem adding the configured products.';

        errorBox.hidden = false;

      }


      console.error(
        'SFG EFI Live cart error:',
        error
      );

    } finally {

      /*
       * The page stays open after a successful add,
       * so always clear the loading lock for the next add.
       */
      delete block.dataset.loading;

    }

  },
  true
);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ez-lynk-add-ons"] && !Shopify.designMode) return;
  try {
    function sfgEzFormatMoney(cents, currency) {

  try {

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-CA',
      {
        style: 'currency',
        currency: currency || 'CAD'
      }
    ).format(cents / 100);

  } catch (error) {

    return (cents / 100).toFixed(2);

  }

}


function sfgEzTuneAddonProperties(sourceProperties) {

  const output = {};
  const wantedKeys = [
    'VIN',
    'Vehicle',
    'Transmission'
  ];

  const source =
    sourceProperties && typeof sourceProperties === 'object'
      ? sourceProperties
      : {};

  wantedKeys.forEach((wantedKey) => {

    const actualKey =
      Object.keys(source).find(
        (key) =>
          String(key).trim().toLowerCase() ===
          wantedKey.toLowerCase()
      );

    if (!actualKey) return;

    const value = source[actualKey];

    if (value !== '' && value != null) {
      output[wantedKey] = value;
    }

  });

  return output;
}


function sfgEzUpdateVisibility(block) {

  block
    .querySelectorAll(
      '[data-sfg-addon-group]'
    )
    .forEach((group) => {

      const addonYes =
        group.querySelector(
          'input[data-sfg-addon-choice][value="yes"]:checked'
        );

      const variantWrap =
        group.querySelector(
          '[data-sfg-addon-variant-wrap]'
        );

      if (variantWrap) {

        variantWrap.hidden =
          !addonYes;

      }

    });

}


function sfgEzUpdateTotal(block) {

  let total =
    Number(
      block.dataset.basePrice || 0
    );

  block
    .querySelectorAll(
      '[data-sfg-addon-group]'
    )
    .forEach((group) => {

      const addonYes =
        group.querySelector(
          'input[data-sfg-addon-choice][value="yes"]:checked'
        );

      if (!addonYes) {
        return;
      }


      const quantity =
        Number(
          addonYes.dataset.addonQuantity || 1
        );

      let unitPrice =
        Number(
          addonYes.dataset.addonUnitPrice || 0
        );


      const variantSelect =
        group.querySelector(
          '[data-sfg-addon-variant]'
        );

      if (variantSelect) {

        const selectedOption =
          variantSelect.selectedOptions[0];

        unitPrice =
          Number(
            selectedOption?.dataset.price || 0
          );

      }


      total +=
        unitPrice * quantity;

    });


  const output =
    block.querySelector(
      '[data-sfg-configured-total]'
    );

  if (output) {

    output.textContent =
      sfgEzFormatMoney(
        total,
        block.dataset.currency
      );

  }

}


let sfgEzVariantSelectionRequest = 0;


function sfgEzNormalizeShopifyId(value) {

  const match =
    String(value || '')
      .match(/(\d+)$/);

  return match
    ? match[1]
    : '';

}


function sfgEzVariantPriceToCents(variant) {

  const amount =
    Number(
      variant?.price?.amount
    );

  if (!Number.isFinite(amount)) {
    return null;
  }

  return Math.round(
    amount * 100
  );

}


document.addEventListener(
  'shopify:product:select',
  (event) => {

    const eventProductId =
      sfgEzNormalizeShopifyId(
        event.product?.id
      );

    if (!eventProductId) {
      return;
    }


    const matchingBlocks =
      Array.from(
        document.querySelectorAll(
          '[data-sfg-ez-addons]'
        )
      ).filter(
        (block) =>
          sfgEzNormalizeShopifyId(
            block.dataset.productId
          ) === eventProductId
      );

    if (!matchingBlocks.length) {
      return;
    }


    const requestToken =
      String(
        ++sfgEzVariantSelectionRequest
      );


    matchingBlocks.forEach(
      (block) => {

        block.dataset.variantPriceRequest =
          requestToken;

      }
    );


    const variantPromise =
      event.promise;

    if (
      !variantPromise ||
      typeof variantPromise.then !== 'function'
    ) {
      return;
    }


    variantPromise
      .then(
        ({ variant }) => {

          if (!variant) {
            return;
          }


          const basePrice =
            sfgEzVariantPriceToCents(
              variant
            );

          if (basePrice == null) {
            return;
          }


          const currency =
            String(
              variant?.price?.currencyCode || ''
            ).trim();


          matchingBlocks.forEach(
            (block) => {

              if (
                !block.isConnected ||
                block.dataset.variantPriceRequest !== requestToken
              ) {
                return;
              }


              block.dataset.basePrice =
                String(basePrice);


              if (currency) {
                block.dataset.currency =
                  currency;
              }


              sfgEzUpdateTotal(block);

            }
          );

        }
      )
      .catch(
        (error) => {

          if (error?.name === 'AbortError') {
            return;
          }

          console.warn(
            'SFG EZ Lynk variant price update failed:',
            error
          );

        }
      );

  }
);


document.addEventListener(
  'change',
  (event) => {

    const block =
      event.target.closest(
        '[data-sfg-ez-addons]'
      );

    if (!block) {
      return;
    }


    sfgEzUpdateVisibility(block);
    sfgEzUpdateTotal(block);

  }
);


document.addEventListener(
  'click',
  async (event) => {

    const button =
      event.target.closest(
        'button[type="submit"][name="add"]'
      );

    if (!button) {
      return;
    }


    const form =
      button.form;

    if (!form) {
      return;
    }


    const block =
      Array.from(
        document.querySelectorAll(
          '[data-sfg-ez-addons]'
        )
      ).find(
        (item) =>
          item.dataset.formId === form.getAttribute('id')
      );


    if (!block) {
      return;
    }


    const anyAddon =
      block.querySelector(
        'input[data-sfg-addon-choice][value="yes"]:checked'
      );


    /*
     * Nothing extra selected:
     * let Horizon handle the normal
     * tuning-product Add to Cart.
     */
    if (!anyAddon) {
      return;
    }


    /*
     * An add-on is selected, so prevent
     * Horizon from separately adding only
     * the main tuning product.
     */
    event.preventDefault();
    event.stopImmediatePropagation();


    if (!form.reportValidity()) {
      return;
    }


    if (block.dataset.loading === '1') {
      return;
    }

    block.dataset.loading = '1';


    const errorBox =
      block.querySelector(
        '[data-sfg-addon-error]'
      );

    if (errorBox) {

      errorBox.hidden = true;
      errorBox.textContent = '';

    }


    try {

      const formData =
        new FormData(form);


      const mainVariantId =
        Number(
          formData.get('id')
        );

      const mainQuantity =
        Number(
          formData.get('quantity')
        ) || 1;


      if (!mainVariantId) {

        throw new Error(
          'Could not determine the selected tuning product.'
        );

      }


      /*
       * Preserve all existing line-item
       * properties from the tuning-product form.
       *
       * This includes your vehicle-information
       * fields without needing EZ Lynk-specific
       * VIN handling here.
       */
      const properties = {};


      for (
        const [key, value]
        of formData.entries()
      ) {

        const match =
          key.match(
            /^properties\[(.+)\]$/
          );

        if (!match) {
          continue;
        }


        const cleanValue =
          typeof value === 'string'
            ? value.trim()
            : value;


        if (
          cleanValue !== '' &&
          cleanValue != null
        ) {

          properties[match[1]] =
            cleanValue;

        }

      }


      const mainItem = {
        id: mainVariantId,
        quantity: mainQuantity
      };


      if (
        Object.keys(properties).length
      ) {

        mainItem.properties =
          properties;

      }


      /*
       * Combine identical variant IDs if
       * the same physical item is somehow
       * selected more than once.
       */
      const itemMap =
        new Map();


      function addItem(
        variantId,
        quantity,
        isTuneAddon = false
      ) {

        const id =
          Number(variantId);

        const qty =
          Number(quantity);


        if (!id || qty < 1) {
          return;
        }


        const tuneAddon =
          Boolean(isTuneAddon);

        const key =
          `${id}:${tuneAddon ? 'tune' : 'plain'}`;

        const existing =
          itemMap.get(key);


        if (existing) {
          existing.quantity += qty;
          return;
        }


        itemMap.set(
          key,
          {
            id,
            quantity: qty,
            isTuneAddon: tuneAddon
          }
        );

      }


      block
        .querySelectorAll(
          '[data-sfg-addon-group]'
        )
        .forEach((group) => {

          const yes =
            group.querySelector(
              'input[data-sfg-addon-choice][value="yes"]:checked'
            );

          if (!yes) {
            return;
          }


          let variantId =
            yes.dataset.addonVariantId;


          /*
           * Multi-variant products such as
           * your switch listings use the
           * selected dropdown variant.
           */
          if (!variantId) {

            const select =
              group.querySelector(
                '[data-sfg-addon-variant]'
              );

            variantId =
              select?.value;

          }


          if (!variantId) {

            throw new Error(
              'Choose an available option for each selected add-on.'
            );

          }


          addItem(
            variantId,
            yes.dataset.addonQuantity || 1,
            group.dataset.sfgTuneAddon === 'true'
          );

        });


      const tuneAddonProperties =
        sfgEzTuneAddonProperties(properties);


      const extras =
        Array.from(
          itemMap.values()
        ).map(
          ({id, quantity, isTuneAddon}) => {

            const item = {
              id,
              quantity
            };


            if (
              isTuneAddon &&
              Object.keys(tuneAddonProperties).length
            ) {
              item.properties = {
                ...tuneAddonProperties
              };
            }


            return item;

          }
        );


      const items = [
        mainItem,
        ...extras
      ];


      /*
       * Add the tune + selected add-ons through Shopify's AJAX
       * cart endpoint. This matches Horizon's own batch-add path
       * and avoids the Storefront API/SFAPI 400 issue.
       */
      const root =
        window.Shopify?.routes?.root || '/';


      const cartComponents =
        Array.from(
          document.querySelectorAll(
            'cart-items-component'
          )
        );


      const sectionIds =
        Array.from(
          new Set(
            cartComponents
              .map(
                (component) =>
                  component.dataset.sectionId
              )
              .filter(Boolean)
          )
        );


      const payload = {
        items
      };


      if (sectionIds.length) {
        payload.sections =
          sectionIds.join(',');
      }


      const response =
        await fetch(
          root + 'cart/add.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },
            body: JSON.stringify(
              payload
            )
          }
        );


      const result =
        await response.json();


      if (!response.ok) {

        throw new Error(
          result.description ||
          result.message ||
          'Unable to add the configured products to cart.'
        );

      }


      /*
       * Horizon's cart-items component listens for the standard
       * cart-lines-update event. Supplying the bundled sections
       * lets it refresh the existing drawer without a page load.
       */
      const cartUpdateEvent =
        new CustomEvent(
          'shopify:cart:lines-update',
          {
            bubbles: true
          }
        );


      cartUpdateEvent.promise =
        Promise.resolve({
          detail: {
            sections:
              result.sections || undefined,
            source: 'sfg-addons',
            didError: false
          }
        });


      document.dispatchEvent(
        cartUpdateEvent
      );


      /*
       * Open Horizon's native cart drawer.
       */
      const openCart =
        window.Shopify?.actions?.openCart;


      if (openCart) {

        await openCart();

      } else {

        window.location.assign(
          root + 'cart'
        );

      }


    } catch (error) {

      delete block.dataset.loading;


      if (errorBox) {

        errorBox.textContent =
          error.message ||
          'There was a problem adding the configured products.';

        errorBox.hidden = false;

      }


      console.error(
        'SFG EZ Lynk cart error:',
        error
      );

    } finally {

      /*
       * The page no longer reloads after a successful add,
       * so always clear the loading lock for the next add.
       */
      delete block.dataset.loading;

    }

  },
  true
);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hp-tuners-add-ons"] && !Shopify.designMode) return;
  try {
    function sfgFormatMoney(cents, currency) {

  try {

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-CA',
      {
        style: 'currency',
        currency: currency || 'CAD'
      }
    ).format(cents / 100);

  } catch (e) {

    return (cents / 100).toFixed(2);

  }

}


function sfgHpTuneAddonProperties(sourceProperties) {

  const output = {};
  const wantedKeys = [
    'VIN',
    'Vehicle',
    'Transmission'
  ];

  const source =
    sourceProperties && typeof sourceProperties === 'object'
      ? sourceProperties
      : {};

  wantedKeys.forEach((wantedKey) => {

    const actualKey =
      Object.keys(source).find(
        (key) =>
          String(key).trim().toLowerCase() ===
          wantedKey.toLowerCase()
      );

    if (!actualKey) return;

    const value = source[actualKey];

    if (value !== '' && value != null) {
      output[wantedKey] = value;
    }

  });

  return output;
}


function sfgHpGetController(block) {

  const formId =
    String(block?.dataset?.formId || '').trim();

  if (!formId) return '';

  /*
   * Vehicle Details can live outside the actual <form> element while its
   * hidden properties are associated to that form with form="...".
   * Therefore form.querySelector() is not sufficient here. Find the
   * Vehicle Details instance for this product form first, then fall back
   * to a document-level form-associated property lookup.
   */
  const vehicleRoot =
    Array.from(document.querySelectorAll('[data-sfg-vehicle-details]'))
      .find((root) => String(root.dataset.formId || '').trim() === formId);

  let input =
    vehicleRoot?.querySelector(
      '[data-sfg-property="ecm-controller"], input[name="properties[ECM Controller]"]'
    ) || null;

  if (!input) {
    input = Array.from(
      document.querySelectorAll(
        '[data-sfg-property="ecm-controller"], input[name="properties[ECM Controller]"]'
      )
    ).find((candidate) => String(candidate.getAttribute('form') || '').trim() === formId) || null;
  }

  const value =
    String(input?.value || '').toUpperCase();

  if (value.includes('E46')) return 'E46';
  if (value.includes('E66')) return 'E66';

  return '';
}


function sfgHpApplyControllerEligibility(block) {

  if (!block) return;

  const controller =
    sfgHpGetController(block);

  block
    .querySelectorAll('[data-sfg-controller-required]')
    .forEach((group) => {

      const required =
        String(
          group.dataset.sfgControllerRequired || ''
        ).toUpperCase();

      if (!required) return;

      const applicable =
        controller !== '' &&
        controller === required;

      /*
       * Hide controller-specific products until a VIN has resolved
       * the ECM, then show only the matching E46/E66 product.
       */
      group.hidden =
        !applicable;

      if (!applicable) {

        const no =
          group.querySelector(
            'input[data-sfg-addon-choice][value="no"], input[data-sfg-nested-addon-choice][value="no"]'
          );

        if (no) {
          no.checked = true;
        }

        const variantWrap =
          group.querySelector(
            '[data-sfg-addon-variant-wrap], [data-sfg-nested-addon-variant-wrap]'
          );

        if (variantWrap) {
          variantWrap.hidden = true;
        }

        const creditPrompt =
          group.querySelector(
            '[data-sfg-addon-credit-prompt], [data-sfg-nested-credit-prompt]'
          );

        if (creditPrompt) {
          creditPrompt.hidden = true;

          const noCredits =
            creditPrompt.querySelector(
              'input[data-sfg-credit-choice][value="no"], input[data-sfg-nested-credit-choice][value="no"]'
            );

          if (noCredits) {
            noCredits.checked = true;
          }
        }
      }
    });

  sfgUpdateTotal(block);
}


function sfgHpApplyAllControllerEligibility() {

  document
    .querySelectorAll('[data-sfg-hp-addons]')
    .forEach((block) => {
      sfgHpApplyControllerEligibility(block);
    });
}


function sfgUpdateTotal(block) {

  let total =
    Number(block.dataset.basePrice || 0);


  block
    .querySelectorAll('[data-sfg-addon-group]')
    .forEach((group) => {

      const addonYes =
        group.querySelector(
          'input[data-sfg-addon-choice][value="yes"]:checked'
        );

      if (!addonYes) return;


      /*
       * Top-level add-on price
       */

      let qty =
        Number(addonYes.dataset.addonQuantity || 1);

      let unitPrice =
        Number(addonYes.dataset.addonUnitPrice || 0);


      const variantSelect =
        group.querySelector(
          '[data-sfg-addon-variant]'
        );


      if (variantSelect) {

        const option =
          variantSelect.selectedOptions[0];

        unitPrice =
          Number(option?.dataset.price || 0);

      }


      total += unitPrice * qty;



      /*
       * Top-level required credits
       */

      const creditYes =
        group.querySelector(
          'input[data-sfg-credit-choice][value="yes"]:checked'
        );


      if (creditYes) {

        total +=
          Number(
            creditYes.dataset.creditUnitPrice || 0
          ) *
          Number(
            creditYes.dataset.creditQuantity || 0
          );

      }



      /*
       * Nested add-ons
       */

      const nestedWrap =
        group.querySelector(
          '[data-sfg-nested-addons]'
        );


      if (!nestedWrap) return;


      nestedWrap
        .querySelectorAll(
          '[data-sfg-nested-addon-group]'
        )
        .forEach((nestedGroup) => {

          const nestedYes =
            nestedGroup.querySelector(
              'input[data-sfg-nested-addon-choice][value="yes"]:checked'
            );

          if (!nestedYes) return;


          let nestedQty =
            Number(
              nestedYes.dataset.nestedAddonQuantity || 1
            );

          let nestedUnitPrice =
            Number(
              nestedYes.dataset.nestedAddonUnitPrice || 0
            );


          const nestedVariantSelect =
            nestedGroup.querySelector(
              '[data-sfg-nested-addon-variant]'
            );


          if (nestedVariantSelect) {

            const option =
              nestedVariantSelect.selectedOptions[0];

            nestedUnitPrice =
              Number(option?.dataset.price || 0);

          }


          total +=
            nestedUnitPrice * nestedQty;



          /*
           * Credits required by the nested add-on itself
           */

          const nestedCreditYes =
            nestedGroup.querySelector(
              'input[data-sfg-nested-credit-choice][value="yes"]:checked'
            );


          if (nestedCreditYes) {

            total +=
              Number(
                nestedCreditYes.dataset.creditUnitPrice || 0
              ) *
              Number(
                nestedCreditYes.dataset.creditQuantity || 0
              );

          }

        });

    });



  const output =
    block.querySelector(
      '[data-sfg-configured-total]'
    );


  if (output) {

    output.textContent =
      sfgFormatMoney(
        total,
        block.dataset.currency
      );

  }

}


let sfgHpVariantSelectionRequest = 0;


function sfgHpNormalizeShopifyId(value) {

  const match =
    String(value || '')
      .match(/(\d+)$/);

  return match
    ? match[1]
    : '';

}


function sfgHpVariantPriceToCents(variant) {

  const amount =
    Number(
      variant?.price?.amount
    );

  if (!Number.isFinite(amount)) {
    return null;
  }

  return Math.round(
    amount * 100
  );

}


document.addEventListener(
  'shopify:product:select',
  (event) => {

    const eventProductId =
      sfgHpNormalizeShopifyId(
        event.product?.id
      );

    if (!eventProductId) {
      return;
    }


    const matchingBlocks =
      Array.from(
        document.querySelectorAll(
          '[data-sfg-hp-addons]'
        )
      ).filter(
        (block) =>
          sfgHpNormalizeShopifyId(
            block.dataset.productId
          ) === eventProductId
      );

    if (!matchingBlocks.length) {
      return;
    }


    const requestToken =
      String(
        ++sfgHpVariantSelectionRequest
      );


    matchingBlocks.forEach(
      (block) => {

        block.dataset.variantPriceRequest =
          requestToken;

      }
    );


    const variantPromise =
      event.promise;

    if (
      !variantPromise ||
      typeof variantPromise.then !== 'function'
    ) {
      return;
    }


    variantPromise
      .then(
        ({ variant }) => {

          if (!variant) {
            return;
          }


          const basePrice =
            sfgHpVariantPriceToCents(
              variant
            );

          if (basePrice == null) {
            return;
          }


          const currency =
            String(
              variant?.price?.currencyCode || ''
            ).trim();


          matchingBlocks.forEach(
            (block) => {

              if (
                !block.isConnected ||
                block.dataset.variantPriceRequest !== requestToken
              ) {
                return;
              }


              block.dataset.basePrice =
                String(basePrice);


              if (currency) {
                block.dataset.currency =
                  currency;
              }


              sfgUpdateTotal(block);

            }
          );

        }
      )
      .catch(
        (error) => {

          if (error?.name === 'AbortError') {
            return;
          }

          console.warn(
            'SFG HP Tuners variant price update failed:',
            error
          );

        }
      );

  }
);






function sfgUpdateMpviDefaultLabel(input) {
  if (!input) return;

  const block = input.closest('[data-sfg-hp-addons]');
  const status = block?.querySelector('[data-sfg-mpvi-label-status]');
  if (!status) return;

  const current = String(input.value || '').replace(/\D/g, '').slice(0, 10);
  const saved = String(input.dataset.defaultMpvi || '').replace(/\D/g, '').slice(0, 10);

  status.textContent = saved && current === saved
    ? '(Default Entered)'
    : '(if owned)';
}


/*
 * Refresh controller-specific unlock visibility whenever the
 * vehicle decoder reports updated vehicle details.
 */
document.addEventListener(
  'sfg:vehicle-details-updated',
  () => {
    sfgHpApplyAllControllerEligibility();
  }
);

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    sfgHpApplyAllControllerEligibility,
    { once: true }
  );
} else {
  sfgHpApplyAllControllerEligibility();
}


/*
 * Uppercase VIN and restrict MPVI serials while typed or pasted.
 */

document.addEventListener(
  'input',
  (event) => {

    if (
      event.target.matches(
        'input[name="properties[VIN]"], input[name="properties[Vin]"], input[name="properties[vin]"]'
      )
    ) {

      event.target.value =
        event.target.value.toUpperCase();

    }

    if (event.target.matches('[data-sfg-mpvi-serial]')) {
      event.target.value = String(event.target.value || '')
        .replace(/\D/g, '')
        .slice(0, 10);

      sfgUpdateMpviDefaultLabel(event.target);
    }

  }
);



document.addEventListener(
  'change',
  (event) => {

    const block =
      event.target.closest(
        '[data-sfg-hp-addons]'
      );

    if (!block) return;



    /*
     * Top-level add-on state
     */

    const group =
      event.target.closest(
        '[data-sfg-addon-group]'
      );


    if (group) {

      const addonYes =
        group.querySelector(
          'input[data-sfg-addon-choice][value="yes"]:checked'
        );


      const variantWrap =
        group.querySelector(
          '[data-sfg-addon-variant-wrap]'
        );


      if (variantWrap) {

        variantWrap.hidden =
          !addonYes;

      }



      const creditPrompt =
        group.querySelector(
          '[data-sfg-addon-credit-prompt]'
        );


      if (creditPrompt) {

        creditPrompt.hidden =
          !addonYes;


        if (!addonYes) {

          const noCredits =
            creditPrompt.querySelector(
              'input[data-sfg-credit-choice][value="no"]'
            );


          if (noCredits) {

            noCredits.checked = true;

          }

        }

      }



      /*
       * Reveal nested products only while their parent add-on
       * is selected.
       */

      const nestedWrap =
        group.querySelector(
          '[data-sfg-nested-addons]'
        );


      if (nestedWrap) {

        nestedWrap.hidden =
          !addonYes;


        /*
         * If the parent is deselected, reset every nested
         * selection so stale options cannot accidentally
         * remain in the configured total/cart.
         */

        if (!addonYes) {

          nestedWrap
            .querySelectorAll(
              '[data-sfg-nested-addon-group]'
            )
            .forEach((nestedGroup) => {

              const nestedNo =
                nestedGroup.querySelector(
                  'input[data-sfg-nested-addon-choice][value="no"]'
                );


              if (nestedNo) {

                nestedNo.checked = true;

              }


              const nestedVariantWrap =
                nestedGroup.querySelector(
                  '[data-sfg-nested-addon-variant-wrap]'
                );


              if (nestedVariantWrap) {

                nestedVariantWrap.hidden = true;

              }


              const nestedCreditPrompt =
                nestedGroup.querySelector(
                  '[data-sfg-nested-credit-prompt]'
                );


              if (nestedCreditPrompt) {

                nestedCreditPrompt.hidden = true;


                const nestedNoCredits =
                  nestedCreditPrompt.querySelector(
                    'input[data-sfg-nested-credit-choice][value="no"]'
                  );


                if (nestedNoCredits) {

                  nestedNoCredits.checked = true;

                }

              }

            });

        }

      }

    }



    /*
     * Nested add-on state
     */

    const nestedGroup =
      event.target.closest(
        '[data-sfg-nested-addon-group]'
      );


    if (nestedGroup) {

      const nestedYes =
        nestedGroup.querySelector(
          'input[data-sfg-nested-addon-choice][value="yes"]:checked'
        );


      const nestedVariantWrap =
        nestedGroup.querySelector(
          '[data-sfg-nested-addon-variant-wrap]'
        );


      if (nestedVariantWrap) {

        nestedVariantWrap.hidden =
          !nestedYes;

      }



      const nestedCreditPrompt =
        nestedGroup.querySelector(
          '[data-sfg-nested-credit-prompt]'
        );


      if (nestedCreditPrompt) {

        nestedCreditPrompt.hidden =
          !nestedYes;


        if (!nestedYes) {

          const noCredits =
            nestedCreditPrompt.querySelector(
              'input[data-sfg-nested-credit-choice][value="no"]'
            );


          if (noCredits) {

            noCredits.checked = true;

          }

        }

      }

    }



    sfgUpdateTotal(block);

  }
);



document.addEventListener(
  'click',
  async (event) => {

    const button =
      event.target.closest(
        'button[type="submit"][name="add"]'
      );

    if (!button) return;


    const form =
      button.form;

    if (!form) return;


    const block =
      Array.from(
        document.querySelectorAll(
          '[data-sfg-hp-addons]'
        )
      ).find(
        (item) =>
          item.dataset.formId ===
          form.getAttribute('id')
      );


    if (!block) return;


    sfgHpApplyControllerEligibility(block);


    const anyAddon =
      block.querySelector(
        'input[data-sfg-addon-choice][value="yes"]:checked'
      );


    /*
     * No extras selected:
     * leave Horizon completely alone.
     */

    if (!anyAddon) return;



    /*
     * Stop Horizon's normal Add to Cart handler.
     */

    event.preventDefault();
    event.stopImmediatePropagation();


    if (!form.reportValidity()) {
      return;
    }


    if (block.dataset.loading === '1') {
      return;
    }


    block.dataset.loading = '1';



    const errorBox =
      block.querySelector(
        '[data-sfg-addon-error]'
      );


    if (errorBox) {

      errorBox.hidden = true;
      errorBox.textContent = '';

    }



    try {

      const formData =
        new FormData(form);


      const mainVariantId =
        Number(formData.get('id'));


      const mainQuantity =
        Number(formData.get('quantity')) || 1;


      if (!mainVariantId) {

        throw new Error(
          'Could not determine the selected tuning product.'
        );

      }



      /*
       * Copy line-item properties from the main product form.
       */

      const properties = {};


      for (
        const [key, value]
        of formData.entries()
      ) {

        const match =
          key.match(
            /^properties\[(.+)\]$/
          );


        if (!match) continue;


        const cleanValue =
          typeof value === 'string'
            ? value.trim()
            : value;


        if (
          cleanValue !== '' &&
          cleanValue != null
        ) {

          properties[match[1]] =
            cleanValue;

        }

      }



      const mainItem = {
        id: mainVariantId,
        quantity: mainQuantity
      };


      if (
        Object.keys(properties).length
      ) {

        mainItem.properties =
          properties;

      }



      /*
       * Map all extra products by variant ID.
       * Duplicate variants automatically have their quantities added.
       */

      const itemMap =
        new Map();


      function addItem(
        variantId,
        quantity,
        isTuneAddon = false
      ) {

        const id =
          Number(variantId);

        const qty =
          Number(quantity);


        if (!id || qty < 1) return;


        const tuneAddon =
          Boolean(isTuneAddon);

        const key =
          `${id}:${tuneAddon ? 'tune' : 'plain'}`;

        const existing =
          itemMap.get(key);


        if (existing) {
          existing.quantity += qty;
          return;
        }


        itemMap.set(
          key,
          {
            id,
            quantity: qty,
            isTuneAddon: tuneAddon
          }
        );

      }



      block
        .querySelectorAll(
          '[data-sfg-addon-group]'
        )
        .forEach((group) => {

          const yes =
            group.querySelector(
              'input[data-sfg-addon-choice][value="yes"]:checked'
            );


          if (!yes) return;



          /*
           * Top-level add-on
           */

          let variantId =
            yes.dataset.addonVariantId;


          if (!variantId) {

            const select =
              group.querySelector(
                '[data-sfg-addon-variant]'
              );

            variantId =
              select?.value;

          }


          addItem(
            variantId,
            yes.dataset.addonQuantity || 1,
            group.dataset.sfgTuneAddon === 'true'
          );



          /*
           * Top-level required credits
           */

          const creditYes =
            group.querySelector(
              'input[data-sfg-credit-choice][value="yes"]:checked'
            );


          if (creditYes) {

            addItem(
              creditYes.dataset.creditVariantId,
              creditYes.dataset.creditQuantity,
              false
            );

          }



          /*
           * Nested add-ons
           */

          const nestedWrap =
            group.querySelector(
              '[data-sfg-nested-addons]'
            );


          if (!nestedWrap) return;


          nestedWrap
            .querySelectorAll(
              '[data-sfg-nested-addon-group]'
            )
            .forEach((nestedGroup) => {

              const nestedYes =
                nestedGroup.querySelector(
                  'input[data-sfg-nested-addon-choice][value="yes"]:checked'
                );


              if (!nestedYes) return;



              let nestedVariantId =
                nestedYes.dataset.nestedAddonVariantId;


              if (!nestedVariantId) {

                const nestedSelect =
                  nestedGroup.querySelector(
                    '[data-sfg-nested-addon-variant]'
                  );


                nestedVariantId =
                  nestedSelect?.value;

              }


              addItem(
                nestedVariantId,
                nestedYes.dataset.nestedAddonQuantity || 1,
                nestedGroup.dataset.sfgTuneAddon === 'true'
              );



              /*
               * Credits required by nested product itself.
               */

              const nestedCreditYes =
                nestedGroup.querySelector(
                  'input[data-sfg-nested-credit-choice][value="yes"]:checked'
                );


              if (nestedCreditYes) {

                addItem(
                  nestedCreditYes.dataset.creditVariantId,
                  nestedCreditYes.dataset.creditQuantity,
                  false
                );

              }

            });

        });



      const tuneAddonProperties =
        sfgHpTuneAddonProperties(properties);


      const extras =
        Array.from(
          itemMap.values()
        ).map(
          ({id, quantity, isTuneAddon}) => {

            const item = {
              id,
              quantity
            };


            if (
              isTuneAddon &&
              Object.keys(tuneAddonProperties).length
            ) {
              item.properties = {
                ...tuneAddonProperties
              };
            }


            return item;

          }
        );


      const items = [
        mainItem,
        ...extras
      ];



      /*
       * Add tune + all selected top-level/nested add-ons
       * through Shopify's AJAX cart endpoint.
       */

      const root =
        window.Shopify?.routes?.root || '/';


      const cartComponents =
        Array.from(
          document.querySelectorAll(
            'cart-items-component'
          )
        );


      const sectionIds =
        Array.from(
          new Set(
            cartComponents
              .map(
                (component) =>
                  component.dataset.sectionId
              )
              .filter(Boolean)
          )
        );


      const payload = {
        items
      };


      if (sectionIds.length) {

        payload.sections =
          sectionIds.join(',');

      }



      const response =
        await fetch(
          root + 'cart/add.js',
          {
            method: 'POST',
            credentials: 'same-origin',

            headers: {
              'Content-Type':
                'application/json',
              'Accept':
                'application/json'
            },

            body: JSON.stringify(
              payload
            )
          }
        );


      const result =
        await response.json();


      if (!response.ok) {

        throw new Error(
          result.description ||
          result.message ||
          'Unable to add the configured products to cart.'
        );

      }



      /*
       * Refresh Horizon's native cart drawer.
       */

      const cartUpdateEvent =
        new CustomEvent(
          'shopify:cart:lines-update',
          {
            bubbles: true
          }
        );


      cartUpdateEvent.promise =
        Promise.resolve({
          detail: {
            sections:
              result.sections || undefined,
            source:
              'sfg-addons',
            didError:
              false
          }
        });


      document.dispatchEvent(
        cartUpdateEvent
      );



      /*
       * Open Horizon's native cart drawer.
       */

      const openCart =
        window.Shopify?.actions?.openCart;


      if (openCart) {

        await openCart();

      } else {

        window.location.assign(
          root + 'cart'
        );

      }



    } catch (error) {

      delete block.dataset.loading;


      if (errorBox) {

        errorBox.textContent =
          error.message ||
          'There was a problem adding the configured products.';

        errorBox.hidden = false;

      }


      console.error(
        'SFG HP Tuners cart error:',
        error
      );


    } finally {

      /*
       * Page remains open after successful add.
       */

      delete block.dataset.loading;

    }

  },
  true
);
  } catch(e) { console.error(e); }
})();

})();
